import React from "react";

export default function Nonorder() {
  return (
    <div>
      <div className="flex mt-16">
        <div class=" inline-flex w-16 mt-3 ml-4 mr-2 bg-blue-300 rounded-full h-0.5 "></div>
        <p className="text-blue-300">Customer</p>
      </div>

      <form className="ml-5">
        <div class="relative z-0 w-full mb-6 group">
          <select
            id="customers"
            class=" border mt-8 border-gray-300 text-gray-500 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-2/3 py-3"
            placeholder=" "
            required
          >
            <option selected>Select Customer</option>
            <option value="US">United States</option>
            <option value="CA">Canada</option>
            <option value="FR">France</option>
            <option value="DE">Germany</option>
          </select>
        </div>

        <div className="flex">
          <div class=" inline-flex w-16 mt-3 mb-3 mr-2 bg-blue-300 rounded-full h-0.5 "></div>
          <p className="text-blue-300">Scheduling</p>
        </div>
        <div class="relative z-0 w-full mb-6 group">
          <input
            type="date"
            name="date"
            class="block py-2.5 px-0 w-2/3 text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
            placeholder="Pick Date "
            required
          />
        </div>
        <div className="flex">
          <div class=" inline-flex w-16 mt-3 mb-3 mr-2 bg-blue-300 rounded-full h-0.5 "></div>
          <p className="text-blue-300">Time</p>
        </div>
        <div class="relative z-0 w-full mb-6 group">
          <input
            type="time"
            name="time"
            class="block py-2.5 px-0 w-2/3 text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer"
            placeholder="Start Time"
            required
          />
        </div>
        
      </form>
    </div>
  );
}
